export const sicCodesList = 'https://www.sec.gov/info/edgar/siccodes.htm';
